import { render, staticRenderFns } from "./new-user.vue?vue&type=template&id=0da9ba0f&scoped=true"
import script from "./new-user.vue?vue&type=script&lang=js"
export * from "./new-user.vue?vue&type=script&lang=js"
import style0 from "./new-user.vue?vue&type=style&index=0&id=0da9ba0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da9ba0f",
  null
  
)

export default component.exports